import {EventSubscriber, HasEventName} from "@/modules/base/events";
import {inject, injectable} from "inversify";
import {AfterTeamCreatedEvent} from "@/modules/team/events/AfterTeamCreatedEvent";
import StadiumFactory from "@/modules/stadium/services/factories/StadiumFactory";
import {Stadium, Terrace} from "@/modules/stadium/entity";
import {ConfigRepository} from "@/modules/base/services/ConfigRepository";

@injectable()
export class GameCreationEventSubscriber implements EventSubscriber {
  constructor(
    @inject(StadiumFactory) private stadiumFactory: StadiumFactory,
    @inject(ConfigRepository) private configRepository: ConfigRepository,
  ) {
  }

  priority(): number {
    return 0;
  }

  init(): { event: HasEventName; callback: (event: any) => void }[] {
    return [
      {event: AfterTeamCreatedEvent, callback: this.onAfterTeamCreatedEvent},
    ];
  }

  async onAfterTeamCreatedEvent(event: AfterTeamCreatedEvent): Promise<void> {
    await this.stadiumFactory.generate(event.team, 1);

    if (event.team.user) {
      const stadium = await Stadium
        .createQueryBuilder('stadium')
        .innerJoinAndSelect('stadium.terraces', 'terrace')
        .innerJoin('stadium.team', 'team')
        .where('team.id = :id', {id: event.team.id})
        .getOneOrFail();

      const terrace = stadium.terraces.find((terrace: Terrace) => terrace.available)!;
      terrace.seats = this.configRepository.get('stadium.startCapacity');
      await terrace.save();
    }
  }
}